import { use } from "i18next";
import { initReactI18next } from "react-i18next";
import cs from "./cs.json";
import en from "./en.json";
import hu from "./hu.json";
import sk from "./sk.json";

const resources = {
  cs: { translation: cs },
  sk: { translation: sk },
  en: { translation: en },
  hu: { translation: hu },
};

use(initReactI18next).init({
  resources,
  lng: "cs",
  fallbackLng: "cs",
  interpolation: {
    escapeValue: false,
  },
});
